import { IconCheckCircleOutlined, IconTasks } from 'common/SVG/svg.common'
import { CardTasksModal } from '../dependencies.style'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { convertDate } from '../ConverDate/convertdate.dependencies'

const TasksModalCommon = (props) => {
  const { dataTasks } = props
  const [isShowMore, setIsShowMoer] = useState(false)

  const renderTaskWhenSelect = () => {
    return dataTasks?.map((item) => (
      <div className='group-task-assinge'>
        <div className='task-name'>
          <div className='dot' />
          <p>{item?.title}</p>
        </div>
        <div className='planned-date'>
          <p>{convertDate(item?.plan_start, item?.plan_end)}</p>
        </div>
      </div>
    ))
  }

  return (
    <CardTasksModal>
      <div className='header-in-card' onClick={() => setIsShowMoer(!isShowMore)}>
        <div className='group-text-header'>
          <IconTasks />
          <p>Tasks</p>
        </div>
        <div style={{ display: 'flex', columnGap: '8px' }}>
          <div className='border-task'>
            <p>{`${dataTasks.length} Task`}</p>
          </div>
          {isShowMore ? (
            <UpOutlined style={{ fontSize: '22px' }} />
          ) : (
            <DownOutlined style={{ fontSize: '22px' }} />
          )}
        </div>
      </div>
      <div className={!isShowMore ? 'more-style' : 'less-style'}>
        {renderTaskWhenSelect()}
      </div>
    </CardTasksModal>
  )
}

export default TasksModalCommon
